import { render, staticRenderFns } from "./etp_events_view.vue?vue&type=template&id=1e548f54&scoped=true"
import script from "./etp_events_view.vue?vue&type=script&lang=js"
export * from "./etp_events_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e548f54",
  null
  
)

export default component.exports